import { render, staticRenderFns } from "./archivo.vue?vue&type=template&id=25ad2ba7"
import script from "./archivo.vue?vue&type=script&lang=js"
export * from "./archivo.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports